import { useMutation } from 'react-query';

import { cartRepository } from '~/api/repository/cart';
import type { UpdateShoppingCartQuantityRequest } from '~/api/data-source/cart';

export type { UpdateShoppingCartQuantityRequest } from '~/api/data-source/cart';

/** 이쿠폰 빠른 구매(장바구니 갱신) */
// PUT /api/market-place/v2/shopping-cart-items/quick/e-coupon
export const useUpdateECouponQuick = () => {
  return useMutation({
    mutationFn: (offerId: number) => cartRepository.updateECouponQuick(offerId),
  });
};

/** 일반 장바구니 수량 갱신 */
// PUT /api/market-place/v2/shopping-cart-items/quantity
export const useUpdateCartQuantity = () => {
  return useMutation({
    mutationFn: (requestBody: UpdateShoppingCartQuantityRequest) =>
      cartRepository.updateCartQuantity(requestBody),
  });
};

/** 바로구매 장바구니 수량 갱신 */
// PUT /api/market-place/v2/shopping-cart-items/quick/quantity
export const useUpdateQuickQuantity = () => {
  return useMutation({
    mutationFn: (requestBody: UpdateShoppingCartQuantityRequest) =>
      cartRepository.updateQuickQuantity(requestBody),
  });
};
